import _ from 'lodash';

const analyticsTypes = {
  MARKETING_HOMEPAGE_TAKEOVER_CLICK: 'marketing_HomepageTakeover_Click',
};

const extractBannerValues = (banner, actionUrl, extra) => ({
  banner_id: _.get(banner, 'id'),
  banner_action_url: actionUrl,
  ...extra,
});

const analyticsActions = [{
  type: analyticsTypes.MARKETING_HOMEPAGE_TAKEOVER_CLICK,
  attributesExtractor: extractBannerValues,
}];

export {
  analyticsTypes,
  analyticsActions,
};

